// extracted by mini-css-extract-plugin
module.exports = {"topic_slide":"topic_slide-1WZCoQxK","slide_box":"slide_box-kk3jtuaZ","dot":"dot-2SO8wiyw","current":"current-325ykp_8 dot-2SO8wiyw"};